// extracted by mini-css-extract-plugin
export var carrierIcon = "_vr-0";
export var carrierLogo = "_vr-1";
export var detailsSection = "_vr-2";